import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface OtrosInvolucrado {
  id?: number;
  id_siniestro?: number;
  tipo_actor_vial: number;
  nombre: string;
  n_documento: number;
  placa: string;
  lesiones: number;
  danos: number;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class OtrosInvolucradosService {
  private apiUrl = `${environment.apiUrl}/api/otros-involucrados`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<OtrosInvolucrado[]> {
    return this.http
      .get<OtrosInvolucrado[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getById(id: string | number): Observable<OtrosInvolucrado> {
    return this.http
      .get<OtrosInvolucrado>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getBySiniestroId(idSiniestro: string | number): Observable<OtrosInvolucrado[]> {
    return this.http
      .get<OtrosInvolucrado[]>(`${environment.apiUrl}/api/siniestro/${idSiniestro}/otros-involucrados`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: OtrosInvolucrado[]): Observable<OtrosInvolucrado[]> {
    return this.http
      .post<OtrosInvolucrado[]>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: string | number, payload: OtrosInvolucrado): Observable<OtrosInvolucrado> {
    return this.http
      .put<OtrosInvolucrado>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
